import { render, staticRenderFns } from "./appOrderManagesList.vue?vue&type=template&id=4616118e&"
import script from "./appOrderManagesList.vue?vue&type=script&lang=js&"
export * from "./appOrderManagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports